import React, { useEffect, useState } from "react";

import BikeCompareComparePage from "../../src/components/BikeCompare/BikeCompareComparePage";
import { BikeCompareStorage } from "../../src/components/BikeCompare/BikeCompareStorage";
import { createFetcher } from "src/lib/fetcher";
import { createItemsBySeoIdBatchQuery } from "../../src/graphql/queries";
import { useRouter } from "next/router";
import useSWR from "swr";
import useTranslation from "next-translate/useTranslation";

const Page = (props) => {
  const { prefetchedData } = props;
  const { lang } = useTranslation("common");
  const router = useRouter();
  const { generic } = router.query;
  const [seoIds, setSeoIds] = useState((generic as string).split("_vs_"));
  const flavor = "biobike";

  useEffect(() => {
    BikeCompareStorage.resetBikes(flavor, seoIds);
    const deregister = BikeCompareStorage.onChange(flavor, (bikes) => {
      const path = bikes.join("_vs_");
      const compare_path = "fahrrad-vergleich";
      if (path.length > 0) {
        router.replace(`/${lang}/${compare_path}/[generic]`, `/${lang}/${compare_path}/${path}`, { shallow: true });
        setSeoIds(bikes);
      } else {
        router.replace(`/${lang}/${compare_path}`, `/${lang}/${compare_path}`);
      }
    });

    return function cleanup() {
      deregister();
    };
  }, [lang, flavor, seoIds, router]);

  const { data } = useSWR(
    [
      createItemsBySeoIdBatchQuery(seoIds),
      JSON.stringify({}),
    ],
    { fallbackData: prefetchedData }
  );

  const products = { data };
  if (!products || !products.data) {
    return null;
  }

  return <BikeCompareComparePage flavor={flavor} seoIds={seoIds} products={products.data} />;
};

Page.getInitialProps = async (context) => {
  const { generic } = context.query;
  const seoIds = generic.split("_vs_");
  const fetcher = createFetcher();
  const prefetchedData = await fetcher([
    createItemsBySeoIdBatchQuery(seoIds),
    JSON.stringify({
      visibility: "public",
    }),
  ]);
  return { prefetchedData };
};

export default Page;
